<template>
  <div id="404">
    <TopBarMinimal />

    <div class="uk-container">
      <div
        class="uk-card uk-card-default uk-card-body uk-margin-large-top uk-width-1-2@m"
      >
        <h3 class="uk-card-title">Whoops, 404 not found!</h3>
        <p><a href="/">click here</a> to get back on track</p>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import TopBarMinimal from "@/components/header/TopBarMinimal.vue";
import Footer from "@/components/footer/Footer.vue";

export default {
  name: "404",
  components: {
    TopBarMinimal,
    Footer
  }
};
</script>
